import { ComponentProps } from "react";
import { useLoadMoreArticlesByProfileId } from "@hooks/useLoadMoreArticlesByProfileId";
import Card from "@particles/card/Card";
import TemplateG from "@particles/card/templates/TemplateG/TemplateG";
import { getTemplateGProps } from "@particles/card/templates/TemplateG/utils/helpers";

type AuthorArticlesProps = {
  /** The articles to be displayed. */
  cardProps: ComponentProps<typeof Card>[];
  /** The ids of the profiles to fetch articles for. */
  profileIds: string[];
};

export default function AuthorArticles({
  cardProps,
  profileIds,
}: AuthorArticlesProps): React.ReactElement {
  const { loadMoreData, ref } = useLoadMoreArticlesByProfileId({
    initialList: cardProps,
    pageSize: 10,
    profileIds,
    templateProps: getTemplateGProps,
  });

  return (
    <div data-testid="author-articles-component">
      <TemplateG cardProps={[...cardProps, ...loadMoreData]} />

      <div ref={ref} />
    </div>
  );
}
